// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2A3O_","title":"Images45_title__wNYEn","images":"Images45_images__PRNby"};